function initNotifyForm() {
  const notifyButtons = document.querySelectorAll('.form_notify_me');
  const formNotify = document.querySelector("#form-notify");
  const modalNotifyForm = document.querySelector('.modal__content-notify-form');
  const modalNotifySuccess = document.querySelector('.modal__content-notify-success');

  const handleNotifyButtonClick = (button) => {
    const variantId = button.getAttribute('data-variant-id');
    const productId = button.getAttribute('data-product_id');
    formNotify.querySelector('[name="Variant_id"]').value = variantId;
    formNotify.querySelector('[name="Product_id"]').value = productId;
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    const klaviyo_public_key = window.klaviyo.klaviyo_public_key;
    const klaviyo_list_all_sub_id = window.klaviyo.klaviyo_list_all_sub_id;
    const variantId = formNotify.querySelector('input[name="Variant_id"]').value;
    const email = formNotify.querySelector('input[name="Email"]').value;
    const isSubscribed = formNotify.querySelector('input[name="subscribe"]').checked;

    if (!klaviyo_public_key || !klaviyo_list_all_sub_id || !variantId || !email) {
      console.warn("Missing required fields");
      return;
    }

    const variantIdFormatted = `$shopify:::$default:::${variantId}`;
    const body = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: { email },
            },
          },
        },
        relationships: {
          variant: {
            data: { type: "catalog-variant", id: variantIdFormatted },
          },
        },
      },
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyo_public_key}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify(body),
        }
      );

      if (response.ok) {
        if (isSubscribed) {
          await subscribeEmail(klaviyo_public_key, klaviyo_list_all_sub_id, email);
        }
        toggleModal(true);
      } else {
        const errorData = await response.json();
        console.error("Failed to add email to list", errorData);
      }
    } catch (error) {
      console.error("Error occurred while adding email to list", error);
    }
  };

  const subscribeEmail = async (publicKey, listId, email) => {
    const payload = new URLSearchParams({
      a: publicKey,
      g: listId,
      email,
      $source: "Back In Stock",
    });

    try {
      const response = await fetch(
        "https://a.klaviyo.com/ajax/subscriptions/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
            "cache-control": "no-cache",
          },
          body: payload,
        }
      );

      console.log("Response from subscribe API:", response);
    } catch (err) {
      console.error("Error subscribing email:", err);
    }
  };

  const toggleModal = (isSuccess) => {
    modalNotifyForm.classList.toggle('hidden', isSuccess);
    modalNotifySuccess.classList.toggle('hidden', !isSuccess);
    formNotify.querySelector('input[name="Name"]').value = '';
    formNotify.querySelector('input[name="Email"]').value = '';
  };

  notifyButtons.forEach((button) =>
    button.addEventListener('click', () => handleNotifyButtonClick(button))
  );

  formNotify.addEventListener("submit", handleFormSubmit);

  document.querySelector('#ModalClose-notify').addEventListener('click', () => toggleModal(false));

  document.addEventListener('click', (event) => {
    const modal = document.querySelector('.product-popup-modal__content-notify');
    if (!modal.contains(event.target)) {
      toggleModal(false);
    }
  });
}

window.addEventListener("load", initNotifyForm);
